export const ACTION_TYPES = {
    ANSWER_QUESTION: 'answer question',
    SELECT_ISSUE: 'select issue',
    ACTIVATE_STEP: 'activate step',
    RESET_STEP: 'reset step',
    TOGGLE_SHARE_POPUP: 'toggle share popup'
};
